/**
 * Shared page-head + hero copy per hub section.
 * Layout merges these defaults with page-level props (page props win).
 */
export const EVENT_PAGE_HEAD_PRESETS = {
  "event-list": {
    Heading: "All Events",
    TitleMark: "All",
    TitleMarkClassName: "event-events-title-mark",
    TitleClassName: "event-events-title",
    HeadClassName: "event-events-head",
    showHero: true,
    heroEyebrow: "DanzFlo events hub",
    heroSub:
      "Discover congresses, festivals, workshops, and dance parties — browse upcoming events and manage your promotions.",
  },
  // calendar: {
  //   Heading: "Calendar",
  //   TitleMark: true,
  //   TitleMarkClassName: "event-calendar-title-mark",
  //   TitleClassName: "event-calendar-title",
  //   HeadClassName: "event-calendar-head",
  //   ExtraclassName: "event-calendar-panel",
  //   showHero: true,
  //   heroEyebrow: "DanzFlo events hub",
  //   heroSub: "View upcoming events on the calendar and plan your schedule.",
  // },
  wishlist: {
    Heading: "Wishlist",
    TitleMark: "W",
    TitleMarkClassName: "event-wishlist-title-mark",
    TitleClassName: "event-wishlist-title",
    HeadClassName: "event-wishlist-head",
    ExtraclassName: "event-wishlist-panel",
    showHero: true,
    heroEyebrow: "DanzFlo events hub",
    heroSub: "Events you have saved for later — review and purchase tickets anytime.",
  },
  "my-events": {
    Heading: "My Events",
    TitleMark: "My",
    TitleMarkClassName: "event-my-events-title-mark",
    TitleClassName: "event-my-events-title",
    HeadClassName: "event-my-events-head",
    ExtraclassName: "event-my-events-panel",
    showHero: true,
    heroEyebrow: "DanzFlo events hub",
    heroSub: "Tickets you have purchased and events you are attending.",
  },
  "my-created-events": {
    Heading: "My Created Events",
    TitleMark: "My",
    TitleMarkClassName: "event-my-events-title-mark",
    TitleClassName: "event-my-events-title",
    HeadClassName: "event-my-events-head",
    ExtraclassName: "event-my-events-panel",
    showHero: true,
    heroEyebrow: "DanzFlo events hub",
    heroSub: "Manage events you have created as an organiser.",
  },
  "my-promoting-events": {
    Heading: "My Promoting Events",
    TitleMark: "My",
    TitleMarkClassName: "event-promoting-title-mark",
    TitleClassName: "event-promoting-title",
    HeadClassName: "event-promoting-head",
    ExtraclassName: "event-promoting-panel",
    showHero: true,
    heroEyebrow: "DanzFlo events hub",
    heroSub: "Events you are promoting and sharing with your audience.",
  },
  orders: {
    Heading: "My Orders",
    TitleMark: true,
    TitleMarkClassName: "event-orders-title-mark",
    TitleClassName: "event-orders-title",
    HeadClassName: "event-orders-head",
    ExtraclassName: "event-orders-panel",
    showHero: false,
  },
  "received-orders": {
    Heading: "Received Orders",
    TitleMark: true,
    TitleMarkClassName: "event-orders-title-mark",
    TitleClassName: "event-orders-title",
    HeadClassName: "event-orders-head",
    ExtraclassName: "event-orders-panel event-received-orders-panel",
    showHero: false,
  },
  attendees: {
    Heading: "Attendee",
    TitleMark: true,
    TitleMarkClassName: "event-attendees-title-mark",
    TitleClassName: "event-attendees-title",
    HeadClassName:
      "event-page-head event-create-head event-create-head--split event-attendees-head",
    ExtraclassName: "event-attendees-panel",
    CreateHead: true,
    showHero: false,
  },
  "my-earnings": {
    Heading: "My Earning",
    TitleMark: true,
    TitleMarkClassName: "event-my-earnings-title-mark",
    TitleClassName: "event-my-earnings-title",
    HeadClassName: "event-my-earnings-head",
    ExtraclassName: "event-my-earnings-panel",
    showHero: false,
  },
  "my-promotion-earnings": {
    Heading: "My Promotion Earnings",
    TitleMark: "My",
    TitleMarkClassName: "event-promoting-title-mark",
    TitleClassName: "event-promoting-title",
    HeadClassName: "event-promoting-head",
    ExtraclassName: "event-promoting-panel",
    showHero: false,
  },
  "promo-code": {
    Heading: "Promocode",
    TitleMark: true,
    TitleMarkClassName: "event-promo-code-title-mark",
    TitleClassName: "event-promo-code-title",
    HeadClassName: "event-promo-code-head",
    ExtraclassName: "event-promo-code-panel",
    showHero: false,
  },
  "assign-guard": {
    Heading: "Assign Guard",
    TitleMark: true,
    TitleMarkClassName: "event-guard-title-mark",
    TitleClassName: "event-guard-title",
    HeadClassName: "event-guard-head",
    ExtraclassName: "event-guard-panel",
    showHero: false,
  },
  notifications: {
    Heading: "Notifications",
    TitleMark: true,
    TitleMarkClassName: "event-notifications-title-mark",
    TitleClassName: "event-notifications-title",
    HeadClassName: "event-notifications-head",
    ExtraclassName: "event-orders-panel event-notifications-panel",
    showHero: false,
  },
  search: {
    Heading: "Search",
    TitleMark: true,
    TitleMarkClassName: "event-events-title-mark",
    TitleClassName: "event-events-title",
    HeadClassName: "event-events-head",
    showHero: false,
  },
};

const HEAD_PROP_KEYS = [
  "Heading",
  "SubHeading",
  "TitleMark",
  "TitleMarkClassName",
  "TitleClassName",
  "HeadClassName",
  "LeftClassName",
  "ExtraclassName",
  "CreateHead",
  "DetailsHead",
  "BackAction",
  "HeadLabel",
  "HeadChip",
  "ButtonHeading",
  "ButtonAction",
  "ButtonIcon",
  "SecondaryButtonHeading",
  "SecondaryButtonAction",
  "SecondaryButtonIcon",
  "heroEyebrow",
  "heroSub",
  "showHero",
];

export function resolveEventPageHead(activeMenuId, pageProps = {}) {
  const preset = EVENT_PAGE_HEAD_PRESETS[activeMenuId] || {};
  const resolved = { ...preset };

  HEAD_PROP_KEYS.forEach((key) => {
    if (pageProps[key] !== undefined && pageProps[key] !== null) {
      resolved[key] = pageProps[key];
    }
  });

  return resolved;
}

export function getHeroTitleFromHead({ Heading, TitleMark, activeMenuId }) {
  if (!Heading) {
    return "Events";
  }

  if (activeMenuId === "event-list") {
    return "Events";
  }

  if (TitleMark === true) {
    return Heading;
  }

  if (typeof TitleMark === "string" && Heading.startsWith(TitleMark)) {
    return Heading;
  }

  return Heading;
}

export const DEFAULT_EVENT_DOCUMENT_TITLE = "Danzflo Events";

/** Tab title for hub pages — clears leftover "Authenticating..." after SSO. */
export function getEventDocumentTitle({ heading, heroTitle, activeMenuId } = {}) {
  const label =
    heroTitle ||
    heading ||
    (activeMenuId === "event-list" ? "Events" : null) ||
    "Events";
  if (!label || /^danzflo events$/i.test(String(label).trim())) {
    return DEFAULT_EVENT_DOCUMENT_TITLE;
  }
  return `${label} | Danzflo Events`;
}
